import signatarioDocumentoProcessoDigital from '@/core/apiclient/processo-digital/signatario/SignatarioDocumentoProcessoDigital'

const URL_PATH = 'api/atas'

export default new signatarioDocumentoProcessoDigital(URL_PATH)
